import { compose } from 'recompose';
import { connect } from 'react-redux';

import withPermissions from '../../../auth/utils/withPermissions';
import DeletedStaffPage from './DeletedStaffPage';
import { canUserViewBarbers, canUserViewStaffManagement } from '../../../common/helpers/users';

export default compose(
  withPermissions,
  connect((state, ownProps) => ({
    canViewDeletedBarbers: canUserViewBarbers(ownProps.permissions),
    canViewDeletedStaff: canUserViewStaffManagement(state),
  }))
)(DeletedStaffPage);
